module.exports = __webpack_public_path__ + "media/icons/etoile_pleine-9a6e36f8.svg";